module.exports = __webpack_public_path__ + "static/media/work4.96cd5ab2.webp";